"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6149],{

/***/ 47853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ AnnouncementModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63233);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15186);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16896);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70178);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84110);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Hiddens_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85607);
/* harmony import */ var _Utils_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3042);





dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_2___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_3___default()));


const AnnouncementModal = (props)=>{
    var ref;
    const { announcement , open , onClose  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Hiddens_Modal__WEBPACK_IMPORTED_MODULE_4__/* .Modal */ .u, {
        visible: open,
        onClose: onClose,
        hideBG: true,
        className: "origin-top !duration-200",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "relative max-w-full w-screen h-screen",
            onClick: onClose,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute top-0 left-0 w-full h-full overflow-auto py-12 flex justify-center items-start",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-prose w-[90%] dark:bg-gray-800 bg-gray-100 col-span-10 p-12 2xl:p-8 xl:gap-6 md:gap-4 rounded-xl shadow-lg flex flex-col gap-8 h-fit",
                    onClick: (e)=>{
                        e.stopPropagation();
                    },
                    children: [
                        announcement.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "dark:text-gray-50 font-montserrat text-4xl font-bold",
                            children: announcement === null || announcement === void 0 ? void 0 : announcement.title
                        }),
                        announcement.user && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-row gap-4 items-center p-2 dark:bg-gray-850 w-fit rounded-xl shadow-lg",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: "w-8 h-8 rounded-full object-cover",
                                    src: announcement.user.picture,
                                    alt: announcement.user.name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "font-wsans text-lg",
                                    children: announcement.user.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col gap-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "dark:text-gray-500 flex flex-row items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            className: "w-5 h-5 mr-2"
                                        }),
                                        announcement.courseID ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "font-wsans",
                                            children: (ref = announcement.course) === null || ref === void 0 ? void 0 : ref.name
                                        }) : "Schoolwide Announcement"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "dark:text-gray-500 flex flex-row items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            className: "w-5 h-5 mr-2"
                                        }),
                                        announcement.created ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                "Created ",
                                                dayjs__WEBPACK_IMPORTED_MODULE_1___default()(announcement.created).format("MMMM DD YYYY"),
                                                " ",
                                                dayjs__WEBPACK_IMPORTED_MODULE_1___default()(announcement.created).format("hh:mm A")
                                            ]
                                        }) : "Unknown Creation Data"
                                    ]
                                }),
                                announcement.updated && announcement.updated !== announcement.created && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "dark:text-gray-500 flex flex-row items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            className: "w-5 h-5 mr-2"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                "Updated ",
                                                dayjs__WEBPACK_IMPORTED_MODULE_1___default()(announcement.updated).format("MMMM DD YYYY"),
                                                " ",
                                                dayjs__WEBPACK_IMPORTED_MODULE_1___default()(announcement.updated).format("hh:mm A")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        !!(announcement === null || announcement === void 0 ? void 0 : announcement.body) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Utils_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            children: (announcement === null || announcement === void 0 ? void 0 : announcement.body) || ""
                        })
                    ]
                })
            })
        })
    });
};


/***/ }),

/***/ 85607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31407);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);




const Modal = (props)=>{
    const { children , onClose , visible , hideBG , className  } = props;
    const [document, setDocument] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setDocument(window.document);
    }, []);
    if (!document) return null;
    return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "z-50 fixed top-0 left-0 w-screen h-screen bg-gray-900 ".concat(visible ? "opacity-40 dark:opacity-80" : "opacity-0 pointer-events-none"),
                onClick: onClose
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Transition */ .u, {
                show: visible,
                enter: "transition ease-out duration-200",
                enterFrom: "opacity-0 scale-0",
                enterTo: "opacity-100 scale-100",
                leave: "transition ease-in duration-75",
                leaveFrom: "opacity-100 scale-100",
                leaveTo: "opacity-0 scale-0",
                as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 ".concat(!hideBG && "dark:bg-gray-800 bg-gray-150", " p-2 rounded-xl dark:text-gray-100 ").concat(className),
                    children: children
                })
            })
        ]
    }), document.getElementById("themeContainer"));
};


/***/ }),

/***/ 3042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Utils_MarkdownRenderer; }
});

// UNUSED EXPORTS: MarkdownRenderer

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 78 modules
var react_markdown = __webpack_require__(59433);
// EXTERNAL MODULE: ./node_modules/rehype-katex/index.js + 14 modules
var rehype_katex = __webpack_require__(29051);
// EXTERNAL MODULE: ./node_modules/katex/dist/katex.min.css
var katex_min = __webpack_require__(41098);
// EXTERNAL MODULE: ./node_modules/remark-gfm/index.js + 24 modules
var remark_gfm = __webpack_require__(39359);
// EXTERNAL MODULE: ./node_modules/remark-math/index.js + 5 modules
var remark_math = __webpack_require__(38522);
// EXTERNAL MODULE: ./node_modules/remark-breaks/index.js
var remark_breaks = __webpack_require__(51356);
// EXTERNAL MODULE: ./node_modules/emoji-js/lib/emoji.js
var emoji = __webpack_require__(94968);
// EXTERNAL MODULE: ./node_modules/rehype-twemojify/index.js + 3 modules
var rehype_twemojify = __webpack_require__(46892);
// EXTERNAL MODULE: ./node_modules/unist-util-visit/index.js
var unist_util_visit = __webpack_require__(6393);
;// CONCATENATED MODULE: ./public/emoji/emojis.json
var emojis_namespaceObject = JSON.parse('["lemonthink","think","lemongod","yayy","sunglas","brainwoke","lemonwoke","blobreach","blobpat"]');
;// CONCATENATED MODULE: ./components/Utils/MarkdownRendererComponents/RehypeCustomEmoji.tsx


const customEmojiRegex = new RegExp("(".concat(emojis_namespaceObject.map((v)=>{
    return ":".concat(v, ":");
}).join("|"), ")"), "g");
const rehypeCustomEmoji = (options)=>{
    return (tree)=>{
        (0,unist_util_visit/* visit */.Vn)(tree, "text", (node)=>{
            let matches = node.value.matchAll(customEmojiRegex);
            if ([
                ...matches
            ].length === 0) {
                return;
            }
            matches = [
                ...node.value.matchAll(customEmojiRegex)
            ];
            node.children = [];
            for (const match of matches){
                if (node.value.indexOf(match[0]) !== 0) {
                    node.children.push({
                        type: "text",
                        value: node.value.slice(0, node.value.indexOf(match[0]))
                    });
                    node.children.push({
                        tagName: "img",
                        type: "element",
                        properties: {
                            alt: node.value.slice(node.value.indexOf(match[0]), node.value.indexOf(match[0]) + match[0].length),
                            className: [
                                options.className
                            ],
                            decoding: "async",
                            draggable: "false",
                            src: "/emoji/svg/".concat(node.value.slice(node.value.indexOf(match[0]) + 1, node.value.indexOf(match[0]) + match[0].length - 1), ".svg")
                        },
                        children: []
                    });
                    node.value = node.value.slice(node.value.indexOf(match[0]) + match[0].length, node.value.length);
                } else {
                    node.children.push({
                        tagName: "img",
                        type: "element",
                        properties: {
                            alt: node.value.slice(0, match[0].length),
                            className: [
                                options.className
                            ],
                            decoding: "async",
                            draggable: "false",
                            src: "/emoji/svg/".concat(node.value.slice(1, match[0].length - 1), ".svg")
                        },
                        children: []
                    });
                    node.value = node.value.slice(match[0].length, node.value.length);
                }
            }
            if (node.value !== "") {
                node.children.push({
                    type: "text",
                    value: node.value
                });
            }
            node.value = undefined;
            node.tagName = "span";
            node.type = "element";
        });
    };
};

// EXTERNAL MODULE: ./utils/hooks/self/useSelfInfo.ts
var useSelfInfo = __webpack_require__(76188);
;// CONCATENATED MODULE: ./components/Utils/MarkdownRendererComponents/RehypeLinks.tsx

// https://stackoverflow.com/questions/3809401/what-is-a-good-regular-expression-to-match-a-url
const urlRegex = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/g;
const rehypeLinks = (options)=>{
    return (tree)=>{
        (0,unist_util_visit/* visit */.Vn)(tree, "text", (node)=>{
            let matches = node.value.matchAll(urlRegex);
            if ([
                ...matches
            ].length === 0) {
                return;
            }
            matches = [
                ...node.value.matchAll(urlRegex)
            ];
            node.children = [];
            for (const match of matches){
                if (node.value.indexOf(match[0]) !== 0) {
                    node.children.push({
                        type: "text",
                        value: node.value.slice(0, node.value.indexOf(match[0]))
                    });
                    node.children.push({
                        tagName: "a",
                        type: "element",
                        properties: {
                            href: node.value.slice(node.value.indexOf(match[0]), node.value.indexOf(match[0]) + match[0].length),
                            className: [
                                options.className
                            ],
                            target: "_blank"
                        },
                        children: [
                            {
                                type: "text",
                                value: node.value.slice(node.value.indexOf(match[0]), node.value.indexOf(match[0]) + match[0].length)
                            }
                        ]
                    });
                    node.value = node.value.slice(node.value.indexOf(match[0]) + match[0].length, node.value.length);
                } else {
                    node.children.push({
                        tagName: "a",
                        type: "element",
                        properties: {
                            href: node.value.slice(0, match[0].length),
                            className: [
                                options.className
                            ],
                            target: "_blank"
                        },
                        children: [
                            {
                                type: "text",
                                value: node.value.slice(0, match[0].length)
                            }
                        ]
                    });
                    node.value = node.value.slice(match[0].length, node.value.length);
                }
            }
            if (node.value !== "") {
                node.children.push({
                    type: "text",
                    value: node.value
                });
            }
            node.value = undefined;
            node.tagName = "span";
            node.type = "element";
            // Stop infinite loop
            return "skip";
        });
    };
};

;// CONCATENATED MODULE: ./components/Utils/MarkdownRendererComponents/RehypeIFrames.tsx

// https://stackoverflow.com/questions/3809401/what-is-a-good-regular-expression-to-match-a-url
const RehypeIFrames_urlRegex = /\!\(((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)\)/g;
const rehypeIFrames = (options)=>{
    return (tree)=>{
        (0,unist_util_visit/* visit */.Vn)(tree, "text", (node)=>{
            let matches = node.value.matchAll(RehypeIFrames_urlRegex);
            if ([
                ...matches
            ].length === 0) {
                // console.log('no matches')
                return;
            }
            matches = [
                ...node.value.matchAll(RehypeIFrames_urlRegex)
            ];
            // console.log('match', matches)
            node.children = [];
            for (const match of matches){
                // console.log('match', match)
                if (node.value.indexOf(match[0]) !== 0) {
                    node.children.push({
                        type: "text",
                        value: node.value.slice(0, node.value.indexOf(match[0]))
                    });
                    // console.log('match[0]', match[0])
                    node.children.push({
                        tagName: "iframe",
                        type: "element",
                        properties: {
                            src: node.value.slice(node.value.indexOf(match[0]), node.value.indexOf(match[0]) + match[0].length),
                            className: [
                                options.className
                            ],
                            target: "_blank"
                        },
                        children: [
                            {
                                type: "text",
                                value: node.value.slice(node.value.indexOf(match[0]), node.value.indexOf(match[0]) + match[0].length - 1)
                            }
                        ]
                    });
                    // console.log(node.children)
                    node.value = node.value.slice(node.value.indexOf(match[0]) + match[0].length, node.value.length);
                } else {
                    node.children.push({
                        tagName: "iframe",
                        type: "element",
                        properties: {
                            src: node.value.slice(0, match[0].length),
                            className: [
                                options.className
                            ]
                        },
                        children: [
                            {
                                type: "text",
                                value: node.value.slice(0, match[0].length)
                            }
                        ]
                    });
                    node.value = node.value.slice(match[0].length, node.value.length);
                }
            }
            if (node.value !== "") {
                node.children.push({
                    type: "text",
                    value: node.value
                });
            }
            node.value = undefined;
            node.tagName = "span";
            node.type = "element";
            // Stop infinite loop
            return "skip";
        });
    };
};

;// CONCATENATED MODULE: ./components/Utils/MarkdownRenderer.tsx







// const SyntaxHighlighter = loadable(() => import('./MarkdownRendererComponents/SyntaxHighlighter'))
// import { prism, dracula } from 'react-syntax-highlighter/dist/cjs/styles/prism'








const ranges = [
    "\xa9|\xae|[ -㌀]|\ud83c[퀀-\udfff]|\ud83d[퀀-\udfff]|\ud83e[퀀-\udfff]",
    " "
].join("|");
const removeEmoji = (str)=>str.replace(new RegExp(ranges, "g"), "").replace(customEmojiRegex, "");
const isOnlyEmojis = (str)=>!removeEmoji(str).length;
const smallEmojis = (str)=>isOnlyEmojis(emojiConverter.replace_colons(str)) && emojiConverter.replace_colons(str).replace(customEmojiRegex, "a").length < 20;
const emojiConverter = new emoji.EmojiConvertor();
emojiConverter.replace_mode = "unified";
var ref;
const recursiveStringifyNode = (node)=>{
    var ref1, ref2, ref3;
    return (node === null || node === void 0 ? void 0 : (ref1 = node.props) === null || ref1 === void 0 ? void 0 : ref1.children) ? node === null || node === void 0 ? void 0 : (ref2 = node.props) === null || ref2 === void 0 ? void 0 : ref2.children.map((v)=>recursiveStringifyNode(v)).join("") : (ref = node === null || node === void 0 ? void 0 : (ref3 = node.props) === null || ref3 === void 0 ? void 0 : ref3.alt) !== null && ref !== void 0 ? ref : node;
};
const MarkdownRenderer = (props)=>{
    const [anonymousDark, setAnonymousDark] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        setAnonymousDark(window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches);
    }, []);
    const user = (0,useSelfInfo/* useCurrentUser */.x)();
    var _className, _className1;
    // const style = user?.theme || (!user && anonymousDark) ? dracula : prism
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
        plugins: [
            remark_gfm/* default */.Z
        ],
        remarkPlugins: [
            remark_math/* default */.Z,
            remark_breaks/* default */.Z
        ],
        rehypePlugins: [
            rehype_katex/* default */.Z,
            [
                rehype_twemojify/* default */.Z,
                {
                    className: smallEmojis(props.children) ? "emoji-large" : "emoji-small",
                    folder: "svg",
                    ext: ".svg"
                }
            ],
            [
                rehypeCustomEmoji,
                {
                    className: smallEmojis(props.children) ? "emoji-large" : "emoji-small"
                }
            ],
            [
                rehypeIFrames,
                {
                    className: "iframe w-full aspect-video rounded-2xl shadow-lg"
                }
            ],
            [
                rehypeLinks,
                {
                    className: "underline text-primary"
                }
            ]
        ],
        className: !props.destyle ? "prose dark:prose dark:prose-invert prose-img:mt-0 prose-img:mb-0 break-words ".concat((_className = props.className) !== null && _className !== void 0 ? _className : "") : "".concat((_className1 = props.className) !== null && _className1 !== void 0 ? _className1 : ""),
        components: {
            code (param) {
                let { node , inline , className , children , ...props } = param;
                const match = /language-(\w+)/.exec(className || "");
                if (Array.isArray(children)) {
                    var ref, ref1;
                    if ((ref = children[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.props) === null || ref1 === void 0 ? void 0 : ref1.children) children = recursiveStringifyNode(children[0]);
                // console.log(children)
                }
                // return match ? (
                //   //@ts-ignore
                //   <SyntaxHighlighter
                //     style={style}
                //     customStyle={{ wordBreak: 'break-word' }}
                //     codeTagProps={{ style: { wordBreak: 'break-word' } }}
                //     language={match[1]}
                //     PreTag="div"
                //     {...props}
                //     wrapLongLines
                //   >
                //     {String(children).replace(/\n$/, '')}
                //   </SyntaxHighlighter>
                // ) :
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                    className: "".concat(className),
                    ...props,
                    children: children
                });
            },
            img (param) {
                let { node , className , children , ...props } = param;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "".concat(className),
                    ...props,
                    referrerPolicy: "no-referrer"
                });
            },
            iframe (param) {
                let { node , className , children , ...props } = param;
                var ref;
                let src = (ref = props.src) === null || ref === void 0 ? void 0 : ref.substring(2, props.src.length - 1);
                if (src === null || src === void 0 ? void 0 : src.match(/^https?:\/\/(www\.)?disadus\.app/)) {
                    return null;
                }
                // enable modest branding on youtube iframe
                if (src === null || src === void 0 ? void 0 : src.match(/^https?:\/\/(www\.)?youtube(-no-cookie)?\.com/)) {
                    src += "&modestbranding=1";
                }
                return /*#__PURE__*/ (0,react.createElement)("iframe", {
                    className: "".concat(className),
                    ...props,
                    src: src,
                    allowFullScreen: true,
                    key: src
                });
            }
        },
        children: emojiConverter.replace_colons(props.children)
    });
};
/* harmony default export */ var Utils_MarkdownRenderer = (MarkdownRenderer);


/***/ }),

/***/ 8010:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


const colors = __webpack_require__(69808);
const plugin = __webpack_require__(42502);
// Rotate X utilities
const rotateX = plugin(function(param) {
    let { addUtilities  } = param;
    addUtilities({
        ".rotate-x-20": {
            transform: "rotateX(20deg)"
        },
        ".rotate-x-40": {
            transform: "rotateX(40deg)"
        },
        ".rotate-x-60": {
            transform: "rotateX(60deg)"
        },
        ".rotate-x-80": {
            transform: "rotateX(80deg)"
        },
        ".rotate-x-160": {
            transform: "rotateX(160deg)"
        },
        ".rotate-x-180": {
            transform: "rotateX(180deg)"
        }
    });
});
module.exports = {
    mode: "jit",
    purge: [
        "./pages/**/*.{js,ts,jsx,tsx}",
        "./components/**/*.{js,ts,jsx,tsx}",
        "./components/**/**/*.{js,ts,jsx,tsx}",
        "./components/**/**/**/*.{js,ts,jsx,tsx}",
        "./components/**/**/**/**/*.{js,ts,jsx,tsx}"
    ],
    darkMode: "class",
    theme: {
        fontFamily: {
            prompt: [
                "Prompt",
                "sans-serif"
            ],
            nunito: [
                "Nunito",
                "sans-serif"
            ],
            roboto: [
                "Roboto",
                "sans-serif"
            ],
            oxygen: [
                "Oxygen",
                "sans-serif"
            ],
            inter: [
                "Inter",
                "sans-serif"
            ],
            shippori: [
                "Shippori Antique B1",
                "sans-serif"
            ],
            varela: [
                "Varela Round",
                "sans-serif"
            ],
            ubuntu: [
                "Ubuntu",
                "sans-serif"
            ],
            // work sans
            wsans: [
                "Work Sans",
                "sans-serif"
            ],
            mono: [
                "Fira Code",
                "monospace"
            ],
            montserrat: [
                "Montserrat",
                "sans-serif"
            ]
        },
        // boxShadow: {
        //   // inner: `box-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05)`,
        //   'inner-lg': `box-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.1)`,
        //   'inner-xl': `box-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.15)`,
        //   'inner-2xl': `box-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.2)`,
        // },
        minWidth: {
            screen: "100vw",
            0: "0",
            1: "0.25rem",
            2: "0.5rem",
            3: "0.75rem",
            4: "1rem",
            5: "1.25rem",
            6: "1.5rem",
            8: "2rem",
            10: "2.5rem",
            12: "3rem",
            16: "4rem",
            20: "5rem",
            24: "6rem",
            32: "8rem",
            40: "10rem",
            48: "12rem",
            56: "14rem",
            64: "16rem",
            72: "18rem",
            80: "20rem",
            88: "22rem",
            96: "24rem",
            112: "28rem",
            128: "32rem",
            144: "36rem",
            160: "40rem",
            176: "44rem",
            192: "48rem",
            208: "52rem",
            224: "56rem",
            240: "60rem",
            256: "64rem",
            272: "68rem",
            288: "72rem",
            304: "76rem",
            320: "80rem",
            336: "84rem",
            352: "88rem",
            368: "92rem",
            384: "96rem",
            400: "100rem",
            416: "104rem",
            432: "108rem",
            448: "112rem",
            464: "116rem",
            480: "120rem",
            496: "124rem",
            512: "128rem"
        },
        minHeight: {
            screen: "100vh",
            0: "0",
            1: "0.25rem",
            2: "0.5rem",
            3: "0.75rem",
            4: "1rem",
            5: "1.25rem",
            6: "1.5rem",
            8: "2rem",
            10: "2.5rem",
            12: "3rem",
            16: "4rem",
            20: "5rem",
            24: "6rem",
            32: "8rem",
            40: "10rem",
            48: "12rem",
            56: "14rem",
            64: "16rem",
            72: "18rem",
            80: "20rem",
            88: "22rem",
            96: "24rem",
            112: "28rem",
            128: "32rem",
            144: "36rem",
            160: "40rem",
            176: "44rem",
            192: "48rem",
            208: "52rem",
            224: "56rem",
            240: "60rem",
            256: "64rem",
            272: "68rem",
            288: "72rem",
            304: "76rem",
            320: "80rem",
            336: "84rem",
            352: "88rem",
            368: "92rem",
            384: "96rem",
            400: "100rem",
            416: "104rem",
            432: "108rem",
            448: "112rem",
            464: "116rem",
            480: "120rem",
            496: "124rem",
            512: "128rem"
        },
        borderRadius: {
            none: "0",
            sm: ".125rem",
            default: ".25rem",
            lg: "0.5rem",
            xl: "0.5rem",
            "2xl": "1rem",
            "3xl": "1.5rem",
            "4xl": "2rem",
            "5xl": "3rem",
            "6xl": "4rem",
            "7xl": "5rem",
            full: "999999px"
        },
        extend: {
            animation: {
                "reverse-spin": "reverse-spin 1s linear infinite",
                shake: "shake 1s cubic-bezier(.36,.07,.19,.97) infinite",
                gradient: "gradient 1s linear infinite",
                "gradient-medium": "gradient 2s linear infinite",
                "gradient-slow": "gradient 3s linear infinite",
                "bounce-mini": "bounce-mini 8s ease-in-out infinite"
            },
            keyframes: {
                "reverse-spin": {
                    from: {
                        transform: "rotate(360deg)"
                    }
                },
                "bounce-mini": {
                    "0%, 100%": {
                        transform: "translateY(0px)"
                    },
                    "50%": {
                        transform: "translateY(15px)"
                    }
                },
                shake: {
                    "10%, 90%": {
                        transform: "translate3d(-1px, 0, 0)"
                    },
                    "20%, 80%": {
                        transform: "translate3d(2px, 0, 0)"
                    },
                    "30%, 50%, 70%": {
                        transform: "translate3d(-4px, 0, 0)"
                    },
                    "40%, 60%": {
                        transform: "translate3d(4px, 0, 0)"
                    }
                },
                gradient: {
                    from: {
                        "background-size": "200%"
                    },
                    to: {
                        "background-position": "200% center",
                        "background-size": "200%"
                    }
                }
            },
            colors: {
                gray: {
                    ...colors.zinc,
                    1000: "#120102",
                    850: "#202023",
                    750: "#333338",
                    650: "#4d4d4f",
                    350: "#bbbbc1",
                    250: "#dcdce0",
                    150: "#ececee"
                },
                primary: {
                    DEFAULT: "#3CAFA3",
                    50: "#BBE8E3",
                    100: "#ABE2DD",
                    200: "#8DD8D0",
                    300: "#6FCEC4",
                    400: "#50C3B8",
                    500: "#3CAFA3",
                    600: "#319087",
                    700: "#27726A",
                    800: "#1D544E",
                    900: "#123532"
                }
            },
            zIndex: {
                "-10": "-10",
                "-20": "-20"
            },
            transitionDelay: {
                400: "400ms",
                600: "600ms"
            },
            transitionDuration: {
                1200: "1200ms"
            },
            translate: {
                "4/3": "133.33%"
            },
            invert: {
                10: ".10",
                20: ".20",
                25: ".25",
                30: ".30",
                40: ".40",
                50: ".5",
                60: ".60",
                70: ".70",
                75: ".75",
                80: ".80",
                90: ".90",
                95: ".95",
                100: "1"
            },
            width: {
                "487px": "487px",
                "screen/2": "50vw",
                "screen/3": "calc(100vw / 3)",
                "screen/4": "calc(100vw / 4)",
                "screen/5": "calc(100vw / 5)",
                "screen/6": "calc(100vw / 6)",
                "2screen/3": "calc(200vw / 3)",
                "3screen/4": "calc(300vw / 4)",
                "4screen/5": "calc(400vw / 5)",
                "5screen/6": "calc(500vw / 6)",
                104: "26rem",
                112: "28rem",
                128: "32rem",
                144: "36rem",
                160: "40rem",
                176: "44rem",
                192: "48rem",
                208: "52rem",
                224: "56rem",
                240: "60rem",
                256: "64rem",
                272: "68rem",
                288: "72rem",
                304: "76rem",
                320: "80rem",
                336: "84rem",
                352: "88rem",
                368: "92rem",
                384: "96rem",
                400: "100rem",
                416: "104rem",
                432: "108rem",
                448: "112rem",
                464: "116rem",
                480: "120rem",
                496: "124rem",
                512: "128rem"
            },
            scale: {
                80: ".8"
            },
            height: {
                112: "28rem",
                128: "32rem",
                144: "36rem",
                160: "40rem",
                176: "44rem",
                192: "48rem",
                208: "52rem",
                224: "56rem",
                240: "60rem",
                256: "64rem",
                272: "68rem",
                288: "72rem",
                304: "76rem",
                320: "80rem",
                336: "84rem",
                352: "88rem",
                368: "92rem",
                384: "96rem",
                400: "100rem",
                416: "104rem",
                432: "108rem",
                448: "112rem",
                464: "116rem",
                480: "120rem",
                496: "124rem",
                512: "128rem",
                "screen/2": "50vh",
                "screen/3": "calc(100vh / 3)",
                "screen/4": "calc(100vh / 4)",
                "screen/5": "calc(100vh / 5)"
            },
            maxHeight: {
                112: "28rem",
                128: "32rem",
                144: "36rem",
                160: "40rem",
                176: "44rem",
                192: "48rem",
                208: "52rem",
                224: "56rem",
                240: "60rem",
                256: "64rem",
                272: "68rem",
                288: "72rem",
                304: "76rem",
                320: "80rem",
                336: "84rem",
                352: "88rem",
                368: "92rem",
                384: "96rem",
                400: "100rem",
                416: "104rem",
                432: "108rem",
                448: "112rem",
                464: "116rem",
                480: "120rem",
                496: "124rem",
                512: "128rem",
                "screen/2": "50vh",
                "screen/3": "calc(100vh / 3)",
                "screen/4": "calc(100vh / 4)",
                "screen/5": "calc(100vh / 5)"
            },
            maxWidth: {
                "487px": "487px"
            },
            fontSize: {
                scaled: "calc(1.1rem + 1vw)"
            }
        },
        screens: {
            inf: {
                max: "99999999px"
            },
            //  => @media (max-width: 99999999px) { ... } Literally so i can use a form of !important
            "4xl": {
                max: "4096px"
            },
            // => @media (max-width: 4096px) { ... } Wtf is this...
            "3.5xl": {
                max: "3096px"
            },
            "3xl": {
                max: "2048px"
            },
            // => @media (max-width: 2048px) { ... }
            "2.5xl": {
                max: "1920px"
            },
            // => @media (max-width: 1920px) { ... }
            "2xl": {
                max: "1535px"
            },
            // => @media (max-width: 1535px) { ... }
            xl: {
                max: "1279px"
            },
            // => @media (max-width: 1279px) { ... }
            lg: {
                max: "1023px"
            },
            // => @media (max-width: 1023px) { ... }
            md: {
                max: "767px"
            },
            // => @media (max-width: 767px) { ... }
            sm: {
                max: "639px"
            },
            // => @media (max-width: 639px) { ... }
            xs: {
                max: "389px"
            }
        }
    },
    variants: {
        extend: {},
        scrollbar: [
            "rounded",
            "dark"
        ]
    },
    plugins: [
        __webpack_require__(33511),
        __webpack_require__(82911),
        __webpack_require__(14852),
        __webpack_require__(54863),
        __webpack_require__(34270),
        rotateX
    ]
};


/***/ }),

/***/ 66313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ CourseAnnouncementsDataClass; }
/* harmony export */ });
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17187);
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(events__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86353);
/* harmony import */ var _PersistentStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76274);
/* harmony import */ var _Fetcher__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69705);
/* harmony import */ var _SocketManager__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77093);





class CourseAnnouncementsDataClass extends (events__WEBPACK_IMPORTED_MODULE_0___default()) {
    static getInstance(courseID) {
        if (!CourseAnnouncementsDataClass._instanceMap.has(courseID)) {
            CourseAnnouncementsDataClass._instanceMap.set(courseID, new CourseAnnouncementsDataClass(courseID));
        }
        return CourseAnnouncementsDataClass._instanceMap.get(courseID);
    }
    async init() {
        this.loadCachedAnnouncements();
        this.getAnnouncements();
        _SocketManager__WEBPACK_IMPORTED_MODULE_3__/* .SocketManager.getInstance */ .C.getInstance().on("cachedCourseAnnouncementsResponse", this.onAnnoucementsData.bind(this));
        _SocketManager__WEBPACK_IMPORTED_MODULE_3__/* .SocketManager.getInstance */ .C.getInstance().on("courseAnnouncementsResponse", this.onAnnoucementsData.bind(this));
    }
    async onAnnoucementsData(announcement) {
        if (announcement.courseID !== this.courseID) return;
        if (announcement.error) return;
        this.announcements = announcement.announcements;
        if (!announcement.cached) {
            this.fresh = true;
        }
        // console.log('announcements', this.announcements)
        this.emit("announcementsUpdate", {
            announcements: this.announcements,
            cached: !!announcement.cached
        });
        await (await _PersistentStore__WEBPACK_IMPORTED_MODULE_1__/* .getPersistentStore */ .f).setItem("course.".concat(this.courseID, ".announcements"), this.announcements);
    }
    async getAnnouncements() {
        let fresh = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        if (localStorage.getItem("token")) return this.getAnnouncementsSocket(fresh);
        return this.getAnnouncementsREST(fresh);
    }
    async getAnnouncementsSocket(fresh) {
        if (fresh) {
            _SocketManager__WEBPACK_IMPORTED_MODULE_3__/* .SocketManager.getInstance */ .C.getInstance().socket.emit("course.announcements", this.courseID);
            return;
        }
        _SocketManager__WEBPACK_IMPORTED_MODULE_3__/* .SocketManager.getInstance */ .C.getInstance().socket.emit("cached.course.announcements", this.courseID);
    }
    async getAnnouncementsREST(fresh) {
        const response = await (0,_Fetcher__WEBPACK_IMPORTED_MODULE_2__/* .fetcher */ ._)("".concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .API_DOMAIN */ .hW, "/courses/").concat(this.courseID, "/announcements").concat(fresh ? "?fresh=true" : ""), undefined, fresh ? "important" : "default");
        const data = await response.json();
        this.announcements = data.announcements;
        if (fresh) {
            this.fresh = true;
        }
        this.emit("announcementsUpdate", {
            announcements: this.announcements,
            cached: false
        });
        await (await _PersistentStore__WEBPACK_IMPORTED_MODULE_1__/* .getPersistentStore */ .f).setItem("course.".concat(this.courseID, ".announcements"), this.announcements);
    }
    async loadCachedAnnouncements() {
        const announcements = await (await _PersistentStore__WEBPACK_IMPORTED_MODULE_1__/* .getPersistentStore */ .f).getItem("course.".concat(this.courseID, ".announcements"));
        if (announcements) {
            this.announcements = announcements;
            this.emit("announcementsUpdate", {
                announcements: this.announcements,
                cached: true
            });
        }
    }
    constructor(courseID){
        super();
        this.announcements = [];
        this.courseID = courseID;
        this.init();
    }
}
CourseAnnouncementsDataClass._instanceMap = new Map();


/***/ }),

/***/ 54175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ screenSmallerThan; }
/* harmony export */ });
/* unused harmony export getCurrentBreakpoint */
/* harmony import */ var tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86926);
/* harmony import */ var tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tailwind_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8010);
/* harmony import */ var _tailwind_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tailwind_config__WEBPACK_IMPORTED_MODULE_1__);

 // Fix the path
const fullConfig = tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0___default()((_tailwind_config__WEBPACK_IMPORTED_MODULE_1___default()));
const getBreakpointValue = (value)=>{
    var ref;
    //@ts-expect-error
    return parseInt((ref = fullConfig.theme.screens[value].max) === null || ref === void 0 ? void 0 : ref.replace("px", ""), 10);
};
const getCurrentBreakpoint = ()=>{
    let currentBreakpoint = "";
    let biggestBreakpointValue = 0;
    try {
        for (const breakpoint of Object.keys(fullConfig === null || fullConfig === void 0 ? void 0 : fullConfig.theme.screens)){
            const breakpointValue = getBreakpointValue(breakpoint);
            if (breakpointValue > biggestBreakpointValue && window.innerWidth >= breakpointValue) {
                biggestBreakpointValue = breakpointValue;
                currentBreakpoint = breakpoint;
            }
        }
        return currentBreakpoint;
    } catch (error) {
        return "";
    }
};
const screenSmallerThan = (breakpoint)=>{
    try {
        return getBreakpointValue(breakpoint) >= window.innerWidth;
    } catch (error) {
        return false;
    }
};


/***/ })

}]);